(function(angular) {
    var mapScript = null;

    class MapLoaderService {
        constructor($log) {
            this.log = $log;
            this.key = "";
        }

        get mapKey() {
            return this.key;
        }

        createMapScriptNode() {
            mapScript = document.createElement('script');
            mapScript.type = 'text/javascript';

            var googleMapScriptUrl = "https://maps.googleapis.com/maps/api/js";//&key=" + data;
            if (this.mapKey)
                googleMapScriptUrl += "?key=" + this.mapKey;
            mapScript.setAttribute('src', googleMapScriptUrl);

            document.head.appendChild(mapScript);
        }

        destroyMapScriptNode() {
            if(mapScript) {
                window.google.maps = null;

                mapScript.parentNode.removeChild( mapScript );
            }
        }

        setKeyFromProfileResponseAndCreateMapScriptNode(data) {
            try {

                if(this.key && this.key !== data.configInfo.mapprovider.google.key) {
                    this.destroyMapScriptNode();
                }

                this.key = data.configInfo.mapprovider.google.key;
            } catch (ex) {
                this.log.warn("MapKeyService::setKeyFromProfileResponse - failed to get key from configInfo.mapprovider.google.key of the setProfile response")
            }

            if (this.key !== "") {
                this.log.info("Google Map API key provided by server: " + this.key);
            } else this.log.warn("MapKeyService::setKeyFromProfileResponse - empty key in configInfo.mapprovider.google.key of the setProfile response");

            if(!mapScript) {
                this.createMapScriptNode();
            }
        }
    }

    angular.module('webcomm').service('mapLoaderService', ['$log', MapLoaderService]);
})(angular);